export function isPastOrDateless(event, nowTs = Math.floor(Date.now() / 1000)) {
	const ts = Number(event.record_date || event.date);
	return !ts || ts <= nowTs;
}

// Numeric-normalized comparison for the events-table "differs from entered date" indicator.
// event.record_date is stored as a number and event.date as a string, so a naive
// `record_date !== date` check is always true whenever record_date is set at all.
export function recordDateDiffers(event) {
	const recordDate = Number(event.record_date);
	if (!recordDate || Number.isNaN(recordDate)) return false;
	const date = Number(event.date);
	if (Number.isNaN(date)) return false;
	return recordDate !== date;
}
